export default __webpack_public_path__ + "static/media/951.43ac3cd6.png";